import { BASE_URL } from "../general/variables";
import { makeSwal } from "../general/functions";
import {
  ajaxToken,
  intlPhone,
  loaderStep,
  templatePackages,
  templatePckgSelected,
} from "./_setup";

let dataForm = {
    token: ajaxToken,
    content: "expo",
  },
  packageSelected = {};
const initListener = () => {
  /* ===================================================================== */
  $('select[name="university"]').on("select2:select", function (e) {
    let data = e.params.data;

    $('input[name="country"]').val(data.country_name);
  });
  /* ===================================================================== */

  $(document).on("click", ".btnAction", async function (e) {
    e.preventDefault();
    let step = $(this).attr("data-step");

    $("#formContainer").append(loaderStep);

    /* SHOW FIRST STEP */
    if (step == "first") {
      let isValid = true;
      await intlPhone.promise;

      $(".uniForm").each(function (i, item) {
        let val = $(item).val();

        if (!val || val.length === 0) {
          $("body").find(".e-backdrop").remove();

          makeSwal("Warning!", $(item).attr("data-error"), "error");

          isValid = false;

          return false; // stop .each()
        }
      });

      if (!isValid) {
        return false; // stop function utama
      }

      dataForm = {
        ...dataForm,
        university: $('select[name="university"]').val(),
        country: $('input[name="country"]').val(),
        pic_name: $('input[name="rep_name"]').val(),
        pic_email: $('input[name="rep_email"]').val(),
        pic_contact: intlPhone.getNumber(),
      };

      triggerCheckParticipants();
    }

    /* SHOW DUPLICATED STEP */
    if (step == "dupeAlert") {
      dataForm = {
        ...dataForm,
        university: $('select[name="university"]').val(),
        country: $('input[name="country"]').val(),
        pic_name: $('input[name="rep_name"]').val(),
        pic_email: $('input[name="rep_email"]').val(),
        pic_contact: intlPhone.getNumber(),
        is_duplicated: "YES",
      };
      console.log("dupeAlert", dataForm);

      $("#containerStepOne").addClass("d-none");
      $("#containerStepTwo").addClass("d-none");
      $("#containerDupeAlert").addClass("d-none");
      triggerCheckParticipants(true);
    }

    /* RELOAD THE PAGE */
    if (step == "reloadPage") {
      location.reload();
    }

    /* RESET STEP TO FIRST FORM */
    if (step == "reset") {
      $("body").find(".e-backdrop").remove();
      $("#containerStepOne").removeClass("d-none");
      $("#containerStepTwo").addClass("d-none");
      $("#containerDupeAlert").addClass("d-none");
      $("#confirmationModalOne").modal("hide");
    }

    /* SHOW SECOND STEP */
    if (step == "second") {
      $("body").find(".e-backdrop").remove();
      $("#containerStepOne").addClass("d-none");
      $("#containerStepTwo").removeClass("d-none");
      $("#containerDupeAlert").addClass("d-none");
      $("#confirmationModalOne").modal("hide");

      $.ajax({
        url: `${BASE_URL}university-api/get-packages`,
        type: "POST",
        data: { university: dataForm.university },
        success: function (resp) {
          $(".expo-list").html("");
          $("body").find(".e-backdrop").remove();
          $('button[data-step="submit"]').show();

          if (resp.length == 0) {
            makeSwal(
              "Error!",
              "Network trouble detected! Please try again later. | Missing Packages",
              "error",
            );
            return;
          }

          resp.forEach((item) => {
            let html = templatePackages
              .replace(/\[PACKAGE_ID\]/g, item.PACKAGE_ID)
              .replace(/\[PACKAGE_INPUT_ID\]/g, `expo${item.PACKAGE_ID}`)
              .replace(/\[PACKAGE_INPUT_FOR\]/g, `expo${item.PACKAGE_ID}`)
              .replace(/\[PACKAGE_NAME\]/g, item.PACKAGE_NAME)
              .replace(/\[PACKAGE_PRICE\]/g, item.PACKAGE_PRICE)
              .replace(/\[PACKAGE_DATE\]/g, item.PACKAGE_DATE ?? 'Date: <span class="label label-inline label-danger fw-bolder">TBC</span>');

            $(".expo-list").append(html);
          });
        },
        error: function (error) {
          $("body").find(".e-backdrop").remove();
          $('button[data-step="submit"]').hide();
          makeSwal(
            "Error!",
            "Network trouble detected! Please try again later. | Missing Packages",
            "error",
          );
        },
      });
    }

    if (step == "submit") {
      dataForm = {
        ...dataForm,
        invoice_billing: $('select[name="invoice_billing"]').val(),
        notes: $("textarea[name='notes']").val(),
      };
      console.log("submit", dataForm);

      handleSubmit();
    }
  });

  /* ===================================================================== */
  $(document).on("change", ".expo-checkbox", function () {
    const selectedPackages = $(".expo-checkbox:checked")
      .map(function () {
        return $(this).val();
      })
      .get();

    dataForm = {
      ...dataForm,
      package: selectedPackages,
    };

    calculateGrandTotal();
  });
  /* ===================================================================== */
};

const triggerCheckParticipants = (forceExist = false) => {
  if (Object.keys(dataForm).length >= 1) {
    setTimeout(() => {
      $.ajax({
        url: `${BASE_URL}university-api/check-participant`,
        data: dataForm,
        type: "POST",
        dataType: "JSON",
        success: function (resp) {
          $("body").find(".e-backdrop").remove();

          if (
            (resp.code == 200 && !resp.exist) ||
            (resp.code == 200 && forceExist)
          ) {
            let picPhone = $('input[name="rep_contact"]').val();
            let picEmail = $('input[name="rep_email"]').val();
            $("#emailModal").text(picEmail);
            $("#phoneModal").text(picPhone);
            $("#containerDupeAlert").addClass("d-none");
            $("#confirmationModalOne").modal("show");
            return;
          }

          if (resp.code == 200 && resp.exist) {
            if (!resp.data.PACKAGES) {
              makeSwal(
                "Error!",
                "Network trouble detected! Please try again later. | Invalid Participant",
                "error",
              );
            }
            $("#containerStepOne").addClass("d-none");
            $("#containerStepTwo").addClass("d-none");
            $("#containerDupeAlert").removeClass("d-none");
            $("#wrapperExpoList").html("");

            let arrPackage = JSON.parse(resp.data.PACKAGES);

            $("#regisAt").text(`Registration Time: ${resp.data.BEAUTY_CREATE}`)
            $("#regisBy").text(`Registered by: ${resp.data.PIC_NAME}`)
            arrPackage.forEach((item, index) => {
              let lastItem = index !== arrPackage.length - 1 ? "" : "d-none";

              let html = templatePckgSelected
                .replace(/\[EXPO_NAME\]/g, `✦ ${item.PACKAGE_NAME}`)
                .replace(/\[EXPO_DATE\]/g, `Date: ${item.EVENT_DATE ?? 'Date: <span class="label label-inline label-danger fw-bolder">TBC</span>'}`)
                .replace(/\[EXPO_CLASS\]/g, lastItem);

              $("#wrapperExpoList").append(html);
            });
            return;
          }
        },
        error: function (error) {
          makeSwal(
            "Error!",
            "Network trouble detected! Please try again later. | Invalid Participant",
            "error",
          );
        },
      });
    }, 2000);
  }
};

const initLoader = () => {
  particlesJS("particleCanvas-Blue", {
    particles: {
      number: {
        value: 100,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#1B5F70",
      },
      shape: {
        type: "circle",
        stroke: {
          width: 0,
          color: "#000000",
        },
        polygon: {
          nb_sides: 3,
        },
        image: {
          src: "img/github.svg",
          width: 100,
          height: 100,
        },
      },
      opacity: {
        value: 0.5,
        random: false,
        anim: {
          enable: true,
          speed: 1,
          opacity_min: 0.1,
          sync: false,
        },
      },
      size: {
        value: 10,
        random: true,
        anim: {
          enable: false,
          speed: 10,
          size_min: 0.1,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
        distance: 150,
        color: "#ffffff",
        opacity: 0.4,
        width: 1,
      },
      move: {
        enable: true,
        speed: 0.5,
        direction: "none",
        random: true,
        straight: false,
        out_mode: "bounce",
        bounce: false,
        attract: {
          enable: false,
          rotateX: 394.57382081613633,
          rotateY: 157.82952832645452,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: true,
          mode: "grab",
        },
        onclick: {
          enable: false,
          mode: "push",
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 200,
          line_linked: {
            opacity: 0.2,
          },
        },
        bubble: {
          distance: 1500,
          size: 40,
          duration: 7.272727272727273,
          opacity: 0.3676323676323676,
          speed: 3,
        },
        repulse: {
          distance: 50,
          duration: 0.4,
        },
        push: {
          particles_nb: 4,
        },
        remove: {
          particles_nb: 2,
        },
      },
    },
    retina_detect: true,
  });

  particlesJS("particleCanvas-White", {
    particles: {
      number: {
        value: 250,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#ffffff",
      },
      shape: {
        type: "circle",
        stroke: {
          width: 0,
          color: "#000000",
        },
        polygon: {
          nb_sides: 3,
        },
        image: {
          src: "img/github.svg",
          width: 100,
          height: 100,
        },
      },
      opacity: {
        value: 0.5,
        random: true,
        anim: {
          enable: false,
          speed: 0.2,
          opacity_min: 0,
          sync: false,
        },
      },
      size: {
        value: 15,
        random: true,
        anim: {
          enable: true,
          speed: 10,
          size_min: 0.1,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
        distance: 150,
        color: "#ffffff",
        opacity: 0.4,
        width: 1,
      },
      move: {
        enable: true,
        speed: 0.5,
        direction: "none",
        random: true,
        straight: false,
        out_mode: "bounce",
        bounce: false,
        attract: {
          enable: true,
          rotateX: 3945.7382081613637,
          rotateY: 157.82952832645452,
        },
      },
    },
    interactivity: {
      detect_on: "canvas",
      events: {
        onhover: {
          enable: false,
          mode: "grab",
        },
        onclick: {
          enable: false,
          mode: "push",
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 200,
          line_linked: {
            opacity: 0.2,
          },
        },
        bubble: {
          distance: 1500,
          size: 40,
          duration: 7.272727272727273,
          opacity: 0.3676323676323676,
          speed: 3,
        },
        repulse: {
          distance: 50,
          duration: 0.4,
        },
        push: {
          particles_nb: 4,
        },
        remove: {
          particles_nb: 2,
        },
      },
    },
    retina_detect: true,
  });
};

const calculateGrandTotal = () => {
  let total = 0,
    ctr = 0;
  $(".expo-checkbox:checked").each(function () {
    total += parseFloat($(this).data("price")) || 0;
    ctr = parseInt(ctr) + 1;
  });

  dataForm = {
    ...dataForm,
    grand_total: total,
  };

  $("#totalExpos").text(`${ctr} selected`);
  $("#grandTotal").text("USD " + total.toLocaleString("en-US"));
};

const handleSubmit = () => {
  if (dataForm.length === 0) {
    makeSwal(
      "Error!",
      "Network trouble detected! Please try again later. | Incomplete Form",
      "error",
    );
  }

  $.ajax({
    url: `${BASE_URL}university-api/submit`,
    type: "POST",
    dataType: "JSON",
    data: dataForm,
    success: function (resp) {
      $("body").find(".e-backdrop").remove();
      window.location.href = `${BASE_URL}/university/thankyou`;
    },
    error: function (err) {
      const { code, header, message, status } = err;
      $("body").find(".e-backdrop").remove();
      makeSwal(header, message, error);
    },
  });
};

export { calculateGrandTotal, initListener };
